<script>
    import Mobilebtn2 from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';
    let main;
    let backClr;
    let text1;
    let container;
    let number;
    export let scrollPointers;
    export let updatedValue;

    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            scrollPointers,
            [
                {scrollValue: 3, duration: 1},
                {
                    scrollValue: 4,
                    duration: 1,
                    onUpdate: () => {
                        if (scrollPointers.scrollValue != 3 && scrollPointers.scrollValue != 4) {
                            updatedValue = scrollPointers.scrollValue;
                        }
                    },
                },
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            backClr,
            [
                {filter: 'brightness(1)', duration: 3},
                {filter: 'brightness(1.8)', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text1,
            [
                {top: 'max(38.785vw,17.956vh)', fontSize: '7.009vw', width: '90vw', x: '17.523vw', duration: 3},
                {bottom: 'max(62.43vw,28.9vh)', x: '0vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            container,
            [
                {y: '-5vw', duration: 3},
                {y: '-50vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            number,
            [
                {y: '-25vw', duration: 3},
                {y: '-30vw', duration: 3},
            ],
            3,
        );
    }
</script>

<section bind:this={main}>
    <div class="main-div" bind:this={backClr}>
       <div  style="width:100%;height:100%;">
        <img
        src="images/Artist/white_castle.png"
        alt=""
        width="100%"
        height="100%"
    />
       </div>

        <div class="text" bind:this={number}><p>3</p></div>
        <div class="container" bind:this={container}>
            <div class="div1">
                <p class="p1" bind:this={text1}>VFX, 3D Environment & Prop Designers</p>
            </div>
            <div class="div2">
                <p class="p2">
                    Realism is about depth and effects. You don’t just create
                    worlds, you make them real so that your audience doesn’t
                    just wow at a flat image but gasps and trips. Your talent is
                    to make them forget the difference between the real world
                    and the imagined one. <br /><br />
                    <strong>
                        We’re building the future where your talents get truly
                        unleashed, where you don't get stuck creating walls and
                        doors, one vertex at a time but cities and planets.
                        Learn and participate.</strong
                    >
                </p>
            </div>
            

            <div class="div4">
                <p class="ar">></p>
            </div>
        </div>
        <div class="div3">
            <Mobilebtn2
                width=" 56.308vw"
                height=" 10.047vw"
                txtsize="2.336vw"
                txtsize2="1.869vw"
                txtcolor="#FFFFFF"
                bgcolor="#4F81BB"
                text2="(3D Seat)"
                state = "Artists & Musicians"
            />
        </div>
    </div>
</section>

<style>
    .main-div {
        overflow: hidden;
        width: 100%;
        height: max(216vw,100vh);
        position: relative;
        filter: brightness(0.4);
    }
    .div1 {
        width: 100%;
        margin-bottom:max(6.776vw,3.137vh);
    }

    .div2 {
        width: 69.159vw;
        margin-left: max(10.514vw, 4.860vh);
        margin-bottom: max(10.748vw,4.968vh);
    }
    .div3 {
        position: absolute;
        height: 100%;
        box-sizing: border-box;
        top: max(188.084vw, 86.933vh);
        left: 0;
        right: 0;
    }

    .div4 {
        height: 2.336vw;
        width: 5.841vw;
        margin: auto;
        margin-top: max(26.2008vw, 12.13vh);
}
    .ar {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 4.673vw;
        line-height: 5.841vw;
        letter-spacing: 0.06em;
        color: #000000;
        transform: rotate(90deg);
    }

    .p1 {
        font-family: "Orbitron";
    font-style: normal;
    font-weight: 700;
    font-size: 9.346vw;
    line-height: 9.346vw;
    /* letter-spacing: 0.06em; */
    text-transform: uppercase;
    color: #000000;
    }

    .p2 {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 140%;
        letter-spacing: 0.06em;
        color: #000000;
    }

    .text {
        position: absolute;
        left: 4.439vw ;
        bottom: max(53.271vw,24.66vh) ;
    }

    .text p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 140.187vw;
        /* line-height: 100%; */
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(160, 204, 255, 0.7);
    }
    .container {
        position: absolute;
        bottom: 0vw;
        height: max(122.514vw, 56.08vh);
        width: 100%;
    }
</style>
